import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=ed1a7594&"
import script from "./personal.vue?vue&type=script&lang=ts&"
export * from "./personal.vue?vue&type=script&lang=ts&"
import style0 from "./personal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports